import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import { DateUtils } from '@grandvisionhq/utils';
import PrescriptionDownloadItem from './PrescriptionDownloadItem.js';
import { logPrescriptionDownloadEvent } from '../../../data-layer/prescriptions.js';

const PrescriptionDownloadItemContainer = ({ prescription  })=>{
    const { getLabel  } = useIntl();
    const onDownload = ()=>{
        logPrescriptionDownloadEvent();
    };
    const formattedDate = DateUtils.toLocalDate(prescription.expiryDate);
    const downloadLabel = getLabel('account.prescription.download');
    const expiryDate = `${getLabel(`account.prescription.${prescription.isValid ? 'expiryDate' : 'expiredDate'}`)} ${formattedDate}`;
    return /*#__PURE__*/ React__default.createElement(PrescriptionDownloadItem, {
        downloadLabel: downloadLabel,
        downloadUrl: prescription.downloadUrl,
        expiryDate: expiryDate,
        isValid: prescription.isValid,
        prescriptionType: prescription.prescriptionType,
        fullName: prescription.fullName,
        onDownload: onDownload
    });
};
var PrescriptionDownloadItemContainer$1 = PrescriptionDownloadItemContainer;

export { PrescriptionDownloadItemContainer$1 as default };
//# sourceMappingURL=PrescriptionDownloadItemContainer.js.map
